export const api_routes_v2 = {
  v2: {
    admin: {
      adminDBMoveDocument: '/v2/admin/adminDBMoveDocument',
      copyAssessmentToUser: '/v2/admin/copyAssessmentToUser',
      duplicateAssessmentInUser: '/v2/admin/duplicateAssessmentInUser',
      getUserInfo: '/v2/admin/getUserInfo',
      getUserInfo2: '/v2/admin/getUserInfo2',
      forceNewTest: '/v2/admin/forceNewTest',
      impact: {
        query: '/v2/admin/impact/query'
      }
    },
    assessment: {
      submitInventory: '/v2/assessment/submitInventory',
      pending: {
        get: {
          getPendingAssessment:
            '/v2/assessment/pending/get/getPendingAssessment'
        }
      },
      get: {
        inventory: '/v2/assessment/get/inventory',
        all: '/v2/assessment/get/all'
      },
      changeAssessmentType: '/v2/assessment/changeAssessmentType',
      enhancedTreatmentRecommendations:
        '/v2/assessment/enhancedTreatmentRecommendations',
      invokeCalculatePatientSubtype:
        '/v2/assessment/invokeCalculatePatientSubtype',
      crud: {
        createAssessment: '/v2/assessment/crud/createAssessment',
        listAssessments: '/v2/assessment/crud/listAssessments',
        cancelAssessment: '/v2/assessment/crud/cancelAssessment',
        startAssessment: '/v2/assessment/crud/startAssessment',
        sendAssessmentEmail: '/v2/assessment/crud/sendAssessmentEmail'
      },
      apiEnqueueCompletedAssessment:
        '/v2/assessment/apiEnqueueCompletedAssessment'
    },
    auth: {
      user: {
        resetPassword: '/v2/auth/user/resetPassword',
        verifyEmail: '/v2/auth/user/verifyEmail',
        sendEmailVerification: '/v2/auth/user/sendEmailVerification',
        register: '/v2/auth/user/register',
        updateProfile: '/v2/auth/user/updateProfile',
        updatePassword: '/v2/auth/user/updatePassword'
      },
      admin: {
        clearPassword: '/v2/auth/admin/clearPassword'
      },
      me: '/v2/auth/me'
    },
    clinic: {
      integration: {
        impact: {
          pilot: {
            toOnboarding: '/v2/clinic/integration/impact/pilot/toOnboarding',
            getFakePilotRedirectParams:
              '/v2/clinic/integration/impact/pilot/getFakePilotRedirectParams'
          },
          addPatient: '/v2/clinic/integration/impact/addPatient',
          token: {
            isValid: '/v2/clinic/integration/impact/token/isValid',
            decodeToken: '/v2/clinic/integration/impact/token/decodeToken',
            generateSampleToken:
              '/v2/clinic/integration/impact/token/generateSampleToken'
          },
          isAssignedToPatientWithPassportId:
            '/v2/clinic/integration/impact/isAssignedToPatientWithPassportId',
          testIntegration: '/v2/clinic/integration/impact/testIntegration'
        }
      },
      accept: '/v2/clinic/accept',
      invite: {
        clinicadmin: '/v2/clinic/invite/clinicadmin',
        clinician: '/v2/clinic/invite/clinician',
        patient: '/v2/clinic/invite/patient'
      },
      remove: {
        patient: '/v2/clinic/remove/patient',
        patientInvite: '/v2/clinic/remove/patientInvite',
        clinician: '/v2/clinic/remove/clinician',
        clinicianInvite: '/v2/clinic/remove/clinicianInvite',
        clinicadmin: '/v2/clinic/remove/clinicadmin'
      },
      globaladmin: {
        join: '/v2/clinic/globaladmin/join',
        leave: '/v2/clinic/globaladmin/leave'
      },
      list: {
        clinics: '/v2/clinic/list/clinics',
        patients: '/v2/clinic/list/patients',
        patientsWithAssessmentStatus:
          '/v2/clinic/list/patientsWithAssessmentStatus',
        clinicians: '/v2/clinic/list/clinicians'
      },
      create: '/v2/clinic/create',
      importTestTakers: '/v2/clinic/importTestTakers',
      info: {
        editRequestImageUploadURL: '/v2/clinic/info/editRequestImageUploadURL',
        edit: '/v2/clinic/info/edit',
        get: {
          all: '/v2/clinic/info/get/all',
          basic: '/v2/clinic/info/get/basic'
        }
      },
      principalUser: {
        submitPrincipalUserConfig:
          '/v2/clinic/principalUser/submitPrincipalUserConfig',
        getLatestPrincipalUser:
          '/v2/clinic/principalUser/getLatestPrincipalUser',
        setPrincipalUser: '/v2/clinic/principalUser/setPrincipalUser'
      },
      role: {
        changeRole: '/v2/clinic/role/changeRole'
      },
      action: {
        patient: {
          editDetails: '/v2/clinic/action/patient/editDetails'
        },
        clinician: {
          editDetails: '/v2/clinic/action/clinician/editDetails'
        },
        resendInvitation: '/v2/clinic/action/resendInvitation',
        getInvitationLink: '/v2/clinic/action/getInvitationLink'
      },
      query: '/v2/clinic/query',
      onboarding: {
        registerUser: '/v2/clinic/onboarding/registerUser',
        registerOrganisation: '/v2/clinic/onboarding/registerOrganisation',
        generateToken: '/v2/clinic/onboarding/generateToken',
        validateToken: '/v2/clinic/onboarding/validateToken',
        claimToken: '/v2/clinic/onboarding/claimToken',
        checkStatus: '/v2/clinic/onboarding/checkStatus'
      },
      billing: {
        buyBulkAssessments: '/v2/clinic/billing/buyBulkAssessments',
        buyOnDemandAssessment: '/v2/clinic/billing/buyOnDemandAssessment',
        getStripeCheckoutPage: '/v2/clinic/billing/getStripeCheckoutPage',
        createCheckoutSession: '/v2/clinic/billing/createCheckoutSession',
        getProductPrice: '/v2/clinic/billing/getProductPrice',
        hasPaymentMethod: '/v2/clinic/billing/hasPaymentMethod',
        hasSubscription: '/v2/clinic/billing/hasSubscription',
        getCustomerSession: '/v2/clinic/billing/getCustomerSession',
        getInvoice: '/v2/clinic/billing/getInvoice',
        cancelSubscription: '/v2/clinic/billing/cancelSubscription',
        getMatchedProducts: '/v2/clinic/billing/getMatchedProducts',
        stripeWebhook: '/v2/clinic/billing/stripeWebhook'
      },
      balance: {
        getBalance: '/v2/clinic/balance/getBalance',
        addBalance: '/v2/clinic/balance/addBalance',
        allocateBalance: '/v2/clinic/balance/allocateBalance',
        consumeBalance: '/v2/clinic/balance/consumeBalance',
        viewUsageHistory: '/v2/clinic/balance/viewUsageHistory',
        viewAggregatedUsageHistory:
          '/v2/clinic/balance/viewAggregatedUsageHistory',
        setProductSupportsOnDemandPurchases:
          '/v2/clinic/balance/setProductSupportsOnDemandPurchases'
      }
    },
    impact: {
      getImpactTestIDFromPassportId: '/v2/impact/getImpactTestIDFromPassportId',
      getImPactTestURL: '/v2/impact/getImPactTestURL',
      impactPassportIdExists: '/v2/impact/impactPassportIdExists',
      receiveImpactScores: '/v2/impact/receiveImpactScores',
      __test__: {
        generateFakeSubmitUrl: '/v2/impact/__test__/generateFakeSubmitUrl'
      }
    },
    pdfExport: {
      pdfExport: '/v2/pdfExport/pdfExport'
    },
    patient: {
      get: {
        assessments: '/v2/patient/get/assessments',
        assessmentsFull: '/v2/patient/get/assessmentsFull',
        patient: '/v2/patient/get/patient',
        profile: '/v2/patient/get/profile'
      },
      impact: {
        profile: '/v2/patient/impact/profile',
        lastTest: '/v2/patient/impact/lastTest'
      },
      list: {
        patientAssessmentIndex: '/v2/patient/list/patientAssessmentIndex'
      },
      assessmentLink: {
        create: '/v2/patient/assessmentLink/create',
        generateToken: '/v2/patient/assessmentLink/generateToken',
        getAllForPatient: '/v2/patient/assessmentLink/getAllForPatient',
        deactivate: '/v2/patient/assessmentLink/deactivate',
        consumeToken: '/v2/patient/assessmentLink/consumeToken'
      },
      loginLink: {
        send: '/v2/patient/loginLink/send',
        create: '/v2/patient/loginLink/create',
        list: '/v2/patient/loginLink/list',
        deactivate: '/v2/patient/loginLink/deactivate',
        getTokenForLink: '/v2/patient/loginLink/getTokenForLink',
        useToken: '/v2/patient/loginLink/useToken'
      }
    },
    clinician: {
      getClinicianData: '/v2/clinician/getClinicianData',
      get: {
        clinician: '/v2/clinician/get/clinician',
        clinicAdmin: '/v2/clinician/get/clinicAdmin'
      }
    },
    uncategorized: {
      'crx-pubmed-query': '/v2/uncategorized/crx-pubmed-query'
    }
  }
} as const;
